"use strict";

import * as bindings from "./bindings";
export const init = function init() {
  bindings.bindActions();
};
